<template>
  <div style="padding: 5px 10px;">
    <v-card :style="{ 'background-color': `${foodDrinkBGColor} !important`}" >
      <v-layout wrap>
        <!-- <v-flex v-bind="{ [`xs${showDishesImage ? 4 : 0}`]: true }"
          style="padding:5px"
        >
          <v-img
            :src="data.FoodImage"
            contain
            aspect-ratio="1"
          />
        </v-flex>
        <v-flex v-bind="{ [`xs${showDishesImage ? 6 : 12}`]: true }"
          style="padding-right:50px;"
        > -->
        <v-flex xs12
        >
        <v-container style="padding: 5px !important">
          <table class="food-result" >
            <tr>
              <td v-if="showDishesImage && data.FoodImage" style="vertical-align:top;max-width:100px;width:30%;">
                <image-in-line :data="data" :locale="locale" />
              </td>
              <td class="name"
                :style="{ 'padding-left' : showDishesImage ? '10px' : '0',
                }">
                <!-- <p
                  v-if="data.FoodVegan"
                  :style="{ 'color': ColorContent,
                    'font-size': `${FontSizeContent}px`,
                    'font-family': FontContent,
                  }"
                >
                  <v-tooltip v-model="showLeaf" top>
                    <template>

                    </template>
                    <span>{{$t('food.vegan')}}</span>
                  </v-tooltip>
                  <v-tooltip v-model="showVegetarian" top>
                    <template >

                    </template>
                    <span>{{$t('food.vegetarian')}}</span>
                  </v-tooltip>

                </p> -->
                <v-tooltip v-model="showLeaf" top>
                  <template>

                  </template>
                  <span>{{$t('food.vegan')}}</span>
                </v-tooltip>
                <v-tooltip v-model="showVegetarian" top>
                  <template >

                  </template>
                  <span>{{$t('food.vegetarian')}}</span>
                </v-tooltip>
                <v-tooltip v-model="showNew" top>
                  <template >

                  </template>
                  <span>{{$t('food.new')}}</span>
                </v-tooltip>
                <v-tooltip v-model="showRecommended" top>
                  <template >

                  </template>
                  <span>{{$t('food.recommended')}}</span>
                </v-tooltip>
                <v-tooltip v-model="showSlowFood" top>
                  <template >
                  </template>
                  <span>Slow food</span>
                </v-tooltip>
                <v-tooltip v-model="showSpicy" top>
                  <template >
                  </template>
                  <span>{{$t('food.spicy')}}</span>
                </v-tooltip>
                <p
                  :style="{ 'color': foodDrinkTextColor,
                    'font-size': `${FontSizeContent}px`,
                    'font-family': FontContent,
                  }"
                  style="margin-bottom: 5px;line-height: 1.2;padding: 5px 0 0 0;"
                >
                  <v-icon v-if="data.FoodVegan && !iconRight" style="color: #a9c366;" @click="showLeaf=!showLeaf">mdi-leaf</v-icon>
                  <v-icon v-if="data.FoodVegetarian && !iconRight" style="color: #436f45;" @click="showVegetarian=!showVegetarian">mdi-leaf</v-icon>
                  <v-icon v-if="data.FoodNew && !iconRight" style="color: red;" @click="showNew=!showNew">mdi-new-box</v-icon>
                  <v-icon v-if="data.FoodRecommended && !iconRight" style="color: orange;" @click="showRecommended=!showRecommended">mdi-star-box</v-icon>
                  <v-icon v-if="data.FoodSlowFood && !iconRight" style="color: red;" @click="showSlowFood=!showSlowFood">mdi-snail</v-icon>
                  <v-icon v-if="data.FoodSpicy && !iconRight" style="color: red;" @click="showSpicy=!showSpicy">mdi-chili-mild</v-icon>
                  {{name}}
                  <v-icon v-if="data.FoodVegan && iconRight" style="color: #a9c366;" @click="showLeaf=!showLeaf">mdi-leaf</v-icon>
                  <v-icon v-if="data.FoodVegetarian && iconRight" style="color: #436f45;" @click="showVegetarian=!showVegetarian">mdi-leaf</v-icon>
                  <v-icon v-if="data.FoodNew && iconRight" style="color: red;" @click="showNew=!showNew">mdi-new-box</v-icon>
                  <v-icon v-if="data.FoodRecommended && iconRight" style="color: orange;" @click="showRecommended=!showRecommended">mdi-star-box</v-icon>
                  <v-icon v-if="data.FoodSlowFood && iconRight" style="color: red;" @click="showSlowFood=!showSlowFood">mdi-snail</v-icon>
                  <v-icon v-if="data.FoodSpicy && iconRight" style="color: red;" @click="showSpicy=!showSpicy">mdi-chili-mild</v-icon>
                </p>
                <!-- <p
                  v-else
                  :style="{ 'color': ColorContent,
                    'font-size': `${FontSizeContent}px`,
                    'font-family': FontContent,
                  }"
                >
                  {{name}}

                </p> -->
                <p
                  :style="{ 'color': ColorContent,
                    'font-size': `${(FontSizeContent - 5)}px`,
                    'font-family': FontContent,
                  }"
                  style="line-height: 1.2;margin-bottom: 5px;padding-top: 5px;"
                >
                  {{ingredients}}
                </p>
                <allergens-in-line  v-if="showDishesAllergens && data && data.FoodAllergens" :allergens="data.FoodAllergens"
                  :columnType="!showDishesImage || !data.FoodImage ? 'xs2' : 'xs3'"/>
                <!-- <p v-if="showDishesAllergens">
  asdfa{{data.FoodAllergens}}
                </p> -->
              </td>
              <td class="price">
                <p
                  style="line-height: 1;padding: 5px 0 0 0;"
                  :style="{ 'color': ColorContent,
                    'font-size': `${FontSizeContent}px`,
                    'font-family': FontContent,
                  }"
                >
                  {{data.FoodPrice}}
                </p>
                <p
                  v-if="note && note.length > 0"
                  style="line-height: 1;margin-top:-10px;"
                  :style="{ 'color': ColorContent,
                    'font-size': `${(FontSizeContent - 5)}px`,
                    'font-family': FontContent,
                  }"
                >
                  {{note}}
                </p>
                <v-layout wrap :class="`justify-end`">
                  <v-flex
                    v-if="data.FoodAllergens && data.FoodAllergens.length && !showDishesAllergens"
                    v-bind="{ [`xs${data.FoodImage && data.FoodAllergens && data.FoodAllergens.length ? 6 : 12}`]: true }"
                    :style="{ 'width' : `${data.FoodImage && data.FoodAllergens && data.FoodAllergens.length ? 75 : 30}px`}"
                  >
                    <allergens :data="data" :locale="locale" />
                  </v-flex>
                  <v-flex
                    v-if="data.FoodImage && !showDishesImage"
                    v-bind="{ [`xs${data.FoodImage && data.FoodAllergens && data.FoodAllergens.length ? 6 : 12}`]: true }"
                    :style="{ 'width' : `${data.FoodImage && data.FoodAllergens && data.FoodAllergens.length ? 75 : 30}px`}"
                  >
                    <image-modal :data="data" :locale="locale" />
                  </v-flex>
                </v-layout>
                <!-- <table v-if="data.FoodImage || (data.FoodAllergens && data.FoodAllergens.length > 0)" >
                  <tr>
                    <td style="text-align:center;width:100px;" v-if="data.FoodAllergens && data.FoodAllergens.length > 0">
                      <allergens :data="data" />
                    </td>
                    <td style="text-align:center;width:50px;" v-if="data.FoodImage" >
                      <image-modal :data="data" />
                    </td>
                  </tr>
                </table>             -->
              </td>
            </tr>
          </table>
        </v-container>
        </v-flex>
        <dish-orders
          v-if="showDishOrder && config && config.FoodDrinkAllowOrders"
          :point="dtouchDishOrder.point"
          :config="config"
          :locale="locale"
          :content="data"
        />
      </v-layout>
    </v-card>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import constants from '@/constants'
  import utils from '@/services/utils'
  import Allergens from './Allergens'
  import ImageModal from './Image'
  import ImageInLine from './ImageInLine'
  import AllergensInLine from './AllergensInLine'
  import DishOrders from './DishOrders'
  export default {
    components: {
      Allergens,
      ImageModal,
      ImageInLine,
      AllergensInLine,
      DishOrders,
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      config: {
        type: Object,
        default: null,
      },
    },
    data: () => ({
      showDishOrder: false,
      showLeaf: false,
      showVegetarian: false,
      showNew: false,
      showRecommended: false,
      showSlowFood: false,
      showSpicy: false,
    }),
    computed: {
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'dtouchDishOrder']),
      isDev () {
        return process.env.VUE_APP_ENV === 'development'
      },
      iconRight () {
        return this.$store.state.app.foodIconRight ? true : false
      },
      name () {
        return this.data.FoodName ? utils.getTranslation (this.data.FoodName, this.locale) : ''
      },
      note () {
        return this.data.FoodNote ? utils.getTranslation (this.data.FoodNote, this.locale) : ''
      },
      ingredients () {
        return this.data.FoodIngredients ? utils.getTranslation (this.data.FoodIngredients, this.locale) : ''
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      foodDrinkTextColor () {
        return this.$store.state.app.foodDrinkTextColor && this.$store.state.app.foodDrinkTextColor !== '' ? this.$store.state.app.foodDrinkTextColor : this.ColorContent
      },
      foodDrinkBGColor () {
        return this.$store.state.app.foodDrinkBGColor && this.$store.state.app.foodDrinkBGColor !== '' ? this.$store.state.app.foodDrinkBGColor : 'white'//'#000000'
      },
      showDishesImage () {
        return this.$store.state.app.showDishesImage ? true : false
      },
      showDishesAllergens () {
        return this.$store.state.app.showDishesAllergens ? true : false
      },
    },
    watch: {
      dtouchDishOrder () {
        this.prepareDishOrder()
      },
      'dtouchDishOrder.token' () {
        this.prepareDishOrder()
      },
    },
    mounted () {
      this.prepareDishOrder()
      //if (this.isDev) this.data.FoodImage='https://www.dtouch.es/assets/040637b2-16ef-44b2-bb91-9c96781c1cbc/15f935d0-e0bc-11ec-b1b3-f39f836341ca.png'
    },
    methods: {
      prepareDishOrder () {
        this.showDishOrder = this.dtouchDishOrder
      },
    },
  }
</script>
<style scoped>
  .food-result {
    table-layout: fixed;
    width: 100% !important;
    max-width: 100% !important;
  }
  .food-result .name {
    width: auto;
  }
  .food-result .price {
    width: 100px;
    /*white-space: nowrap;*/
    text-align: right;
    vertical-align: top;
  }
</style>
